import { Spin } from "antd";
import { ConditionalRenderer } from "components";
import { useGetData } from "./hooks/useGetData";
import { ChartHeader, SubscribersBarChart } from "./components";
import styles from "./styles.module.scss";

export const SubscribersGrowth = ({ height }) => {
  const {
    maxValue,
    subscribersGrowth,
    subscribersGrowthLoading,
    aggregatedMonthsData,
  } = useGetData();

  return (
    <Spin spinning={subscribersGrowthLoading}>
      <div className={styles.subscribersGrowth}>
        <ChartHeader />
        <ConditionalRenderer
          condition={!subscribersGrowthLoading && subscribersGrowth}
        >
          <SubscribersBarChart
            aggregatedMonthsData={aggregatedMonthsData}
            height={height}
            maxValue={maxValue}
          />
        </ConditionalRenderer>
        <ConditionalRenderer
          condition={!subscribersGrowthLoading && !subscribersGrowth}
        >
          <h1
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "rem",
            }}
          >
            No Data Found
          </h1>
        </ConditionalRenderer>
      </div>
    </Spin>
  );
};
